export default __webpack_public_path__ + "static/pu-img-banner-up-2-6bfecd6fda89870c3aa9effadf89cc72.jpg";